import { render, staticRenderFns } from "./BeTopHeader.vue?vue&type=template&id=9f2c27f4&"
import script from "./BeTopHeader.vue?vue&type=script&lang=js&"
export * from "./BeTopHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports